/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxTooltipComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxtooltip';

/**
 * Tooltip
 */

export class NgcToolTipComponent extends ControlComponent {
     absolutePositionX: any;
     absolutePositionY: any;
     autoHide: any;
     autoHideDelay: any;
     animationShowDelay: any;
     animationHideDelay: any;
     content: any;
     closeOnClick: any;
     disabled: any;
     enableBrowserBoundsDetection: any;
     left: any;
     name: any;
     opacity: any;
     position: any;
     rtl: any;
     showDelay: any;
     showArrow: any;
     top: any;
     trigger: any;
     theme: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-tooltip',
    template: `<jqxTooltip
                [absolutePositionX] = "absolutePositionX"
                [absolutePositionY] = "absolutePositionY"
                [autoHide] = "autoHide"
                [autoHideDelay] = "autoHideDelay"
                [animationShowDelay] = "animationShowDelay"
                [animationHideDelay] = "animationHideDelay"
                [content] = "content"
                [closeOnClick] = "closeOnClick"
                [disabled] = "disabled"
                [enableBrowserBoundsDetection] = "enableBrowserBoundsDetection"
                [left] = "left"
                [name] = "name"
                [opacity] = "opacity"
                [position] = "position"
                [rtl] = "rtl"
                [showDelay] = "showDelay"
                [showArrow] = "showArrow"
                [top] = "top"
                [trigger] = "trigger"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxTooltip>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'absolutePositionX': [{ type: Input, args: ['absolutePositionX', ] },],
'absolutePositionY': [{ type: Input, args: ['absolutePositionY', ] },],
'autoHide': [{ type: Input, args: ['autoHide', ] },],
'autoHideDelay': [{ type: Input, args: ['autoHideDelay', ] },],
'animationShowDelay': [{ type: Input, args: ['animationShowDelay', ] },],
'animationHideDelay': [{ type: Input, args: ['animationHideDelay', ] },],
'content': [{ type: Input, args: ['content', ] },],
'closeOnClick': [{ type: Input, args: ['closeOnClick', ] },],
'disabled': [{ type: Input, args: ['disabled', ] },],
'enableBrowserBoundsDetection': [{ type: Input, args: ['enableBrowserBoundsDetection', ] },],
'left': [{ type: Input, args: ['left', ] },],
'name': [{ type: Input, args: ['name', ] },],
'opacity': [{ type: Input, args: ['opacity', ] },],
'position': [{ type: Input, args: ['position', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'showDelay': [{ type: Input, args: ['showDelay', ] },],
'showArrow': [{ type: Input, args: ['showArrow', ] },],
'top': [{ type: Input, args: ['top', ] },],
'trigger': [{ type: Input, args: ['trigger', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
};
}

/**
 * Tooltip Module
 */

export class NgcTooltipModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [NgcToolTipComponent],
    declarations: [NgcToolTipComponent, jqxTooltipComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
